
import { UserRole } from '@/lib/supabase';
import { useSignIn } from './auth/useSignIn';
import { useSignUp } from './auth/useSignUp';
import { useSignOut } from './auth/useSignOut';
import { useRoleCheck } from './auth/useRoleCheck';
import { usePasswordReset } from './auth/usePasswordReset';

export interface UseAuthMethodsReturn {
  signIn: (email: string, password: string) => Promise<{ success: boolean }>;
  signUp: (email: string, password: string) => Promise<{ success: boolean; requiresEmailVerification?: boolean }>;
  signOut: () => Promise<void>;
  hasRole: (roles: UserRole | UserRole[]) => boolean;
  validatePassword: (password: string) => { valid: boolean; errors: string[] };
  resetPassword: (email: string) => Promise<{ success: boolean; error?: string }>;
  confirmPasswordReset: (token: string, newPassword: string) => Promise<{ success: boolean; error?: string }>;
}

export const useAuthMethods = (profile: any): UseAuthMethodsReturn => {
  const { signIn } = useSignIn();
  const { signUp, validatePassword } = useSignUp();
  const { signOut } = useSignOut();
  const { hasRole } = useRoleCheck(profile);
  const { resetPassword, confirmPasswordReset } = usePasswordReset();

  return {
    signIn,
    signUp,
    signOut,
    hasRole,
    validatePassword,
    resetPassword,
    confirmPasswordReset
  };
};
